import React, { useState } from 'react';
import { RadioGroup } from '@mui/material';
import { useField, useFormikContext } from 'formik';

const RadioWrapper = ({ name, label, legend, children, ...otherProps }) => {
  const { setFieldValue } = useFormikContext();
  const [field, mata] = useField(name);
  const [selectedvalue, setSelectedValue] = useState();
  const handleChange = (evt) => {
    const { value } = evt.target;
    setFieldValue(name, value === 'true');
    setSelectedValue(value === 'true');
  };

  const configRadio = {
    ...field,
    ...otherProps,
    onChange: handleChange,
    value: field.value === null ? selectedvalue : field.value,
  };

  return (
    <>
      <RadioGroup {...configRadio}>{children}</RadioGroup>

      {mata && mata.touched && mata.error && <span style={{ color: '#d32f2f' }}>{mata.error}</span>}
    </>
  );
};

export default RadioWrapper;
